var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmtyPhotosIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.25,
    height: 29.257,
    viewBox: "0 0 29.25 29.257",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-md-photos",
    "data-name": "Icon ionic-md-photos",
    transform: "translate(-3.375 -3.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_893",
    "data-name": "Path 893",
    d: "M28.125,29.623V10.877a3.01,3.01,0,0,0-3-3H6.377a3.01,3.01,0,0,0-3,3V29.63a3.01,3.01,0,0,0,3,3H25.13A3.019,3.019,0,0,0,28.125,29.623ZM11.06,21.375l3.185,4.5,4.69-6.75,6.188,9H6.377Z",
    fill: "#e5e5e5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_894",
    "data-name": "Path 894",
    d: "M29.623,3.375H10.877a3.01,3.01,0,0,0-3,3V6.75H26.248a3.01,3.01,0,0,1,3,3V28.125h.373a3.01,3.01,0,0,0,3-3V6.377A3.01,3.01,0,0,0,29.623,3.375Z",
    fill: "#e5e5e5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmtyPhotosIcon);
export default __webpack_public_path__ + "static/media/emty-photos-icon.81528f484188f4c8c8584ecdfdd0d400.svg";
export { ForwardRef as ReactComponent };